import { saveAs } from "file-saver";
import Vue from "vue";

Vue.mixin({
  methods: {
    go(path) {
      this.$router.push(`/${path}`);
    },
    getValueByField(row, field) {
      // if(Array.isArray())
      console.log(row);
      let split = field.field.split(".");
      let value = row;
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        if(!value) return;
        if(typeof value != "object") return;
        if(Array.isArray(value[f]) && split.length >= 2) {
          let list = value[f];
          value = list.map(arr=>arr[split[1]]).join(", ");

        }else {
          value = value.hasOwnProperty(f) ? value[f] : "";
        }
      });
      return value;
    },
    getFormatTime(sec) {
      let h = Math.floor(sec/(60*60));
      let m = Math.floor(sec/(60)) - h*60;
      let s = sec%60;

      return `
      <div class="wrap">
        <div class="value">${!isNaN(h) ? h : "---"}</div>
        <div class="unit">${ this.$t("dashboard.unit.time.hr") }</div>
      </div>
      <div class="wrap">
        <div class="value">${!isNaN(m) ? m : "---"}</div>
        <div class="unit">${ this.$t("dashboard.unit.time.min") }</div>
      </div>
      `;
    },
    // exportExcel(setting, params) {
    //   let str = "data:application/vnd.ms-excel,";
    //   let excel_content = `
    //     <table>
    //       <tr bgcolor="#87AFC6">
    //         <td>header</td>
    //       </tr>
    //       <tr>
    //         <td>data</td>
    //       </tr>
    //     </table>
    //   `;
    //   window.open(str+encodeURIComponent(excel_content));
    // }
    
    async exportExcel(key, setting, params, custom_name=false) {
      const loading = this.$loading({
        lock: true,
        // text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      await this.$axios.get(`/${key}/export/excel`, {
        responseType: 'blob',
        params: {
          ...params,
          headers: decodeURI(encodeURI(setting.fields.map(f=>this.tran(key, f.key)))),
          column: decodeURI(encodeURI(setting.fields.map(f=>f.key))),
          columns: decodeURI(encodeURI(setting.fields.map(f=>f.field?f.field:f.key))),
          sheet_name: decodeURI(this.$te(`menu.item.${setting.key}`) ? this.$t(`menu.item.${setting.key}`) : setting.key)
        }
      }).then(res=>{
        let data = res.data;
        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // var href = URL.createObjectURL(blob);
      //   window.open(href);
      let date_format = this.$moment().format("YYYYMMDD_hhmmss")
      if(custom_name) {
        saveAs(blob, `${custom_name}_${date_format}.xlsx`);
      }else {
        saveAs(blob, this.$t('menu.item.'+setting.key)+`_${date_format}.xlsx`);
      }
        return true;
      }).catch(err=>{ return false; });
      loading.close();
      this.$store.commit("control/setLoad", false);

    },
    async exportPdf(key, setting, id, custom_name=false) {
      const loading = this.$loading({
        lock: true,
        // text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      await this.$axios.get(`/${key}/export/pdf/${id}`, {
        responseType: 'blob'
      }).then(res=>{
        let data = res.data;
        console.log(data);
        var blob = new Blob([data], { type: 'application/pdf' });
      
        // var href = URL.createObjectURL(blob);
        //   window.open(href);
        let date_format = this.$moment().format("YYYYMMDD_hhmmss")
        if(custom_name) {
          saveAs(blob, `${custom_name}_${date_format}.pdf`);
        }else {
          saveAs(blob, this.$t('menu.item.'+setting.key)+`_${date_format}.pdf`);
        }
        return true;
      }).catch(err=>{ return false; });
      loading.close();
      this.$store.commit("control/setLoad", false);

    },

    tran(key, field) {
      let normal = `field.${key}.${field}`;
      if(this.$te(normal)) {
        return this.$t(normal);
      }else if(this.$te(`field.general.${field}`)) {
        return this.$t(`field.general.${field}`)
      }else {
        return field;
      }
    },
    arrToParams(arr) {
      let param = "";
      arr.map(p=>{
        param += `&${p.key}=${p.value}`;
      })
      return param;
    }
  },
  filters: {
    current(value) {
      return `${value}A`;
    }
  }
});